/**
 * Session-local footage previews for the A-Roll ingest wait.
 *
 * While a file uploads (and then encodes on Mux) the ONLY copy of the
 * footage we can show is the local File the user just dropped. Each
 * upload registers an object URL here, keyed by job + filename — the
 * same pair the server row carries — so the uploader row and the
 * transcribing stage can both play the clip blurred behind their copy
 * long before Mux storyboards exist.
 *
 * URLs live for the page's lifetime (an object URL is a handle, not a
 * copy — the browser frees it on unload). release() exists for the
 * paths that know the preview is done (upload failed, asset READY).
 */
const previews = new Map<string, string>();

const key = (jobId: string, filename: string) => `${jobId} ${filename}`;

export function registerLocalPreview(jobId: string, file: File): string {
  const k = key(jobId, file.name);
  const existing = previews.get(k);
  if (existing) URL.revokeObjectURL(existing);
  const url = URL.createObjectURL(file);
  previews.set(k, url);
  return url;
}

export function getLocalPreview(jobId: string, filename: string): string | null {
  return previews.get(key(jobId, filename)) ?? null;
}

export function releaseLocalPreview(jobId: string, filename: string): void {
  const k = key(jobId, filename);
  const url = previews.get(k);
  if (url) {
    URL.revokeObjectURL(url);
    previews.delete(k);
  }
}
